export const ElementCategory = {
  PAGE: "page" as const,
  RAW: "raw" as const,
  HERO: "hero" as const,
  WRAPPER: "wrapper" as const,
  SECTION: "section" as const,
  COLUMN: "column" as const,
  GROUP: "group" as const,
  TEXT: "text" as const,
  TABLE: "table" as const,
  BUTTON: "button" as const,
  IMAGE: "image" as const,
  DIVIDER: "divider" as const,
  NAVBAR: "navbar" as const,
  NAVBAR_LINK: "navbar-link" as const,
  SOCIAL: "social" as const,
  SOCIAL_ELEMENT: "social-element" as const,
  SPACER: "spacer" as const,
  TEXT_LIST: "text-list" as const,
  TEXT_LIST_ITEM: "text-list-item" as const,
  INLINE_TEXT: "inline-text" as const,
  BLOCK_NODE: "block-node" as const,
  DANGEROUS_CODE: "dangerous_code" as const,
  UNKNOWN_CONTENT: "unknown-content " as const,
  UNSET: "unset" as const, // like navbar-link ,social-element
  UNSET_RENDER: "unset-render" as const,
  TABLE2_TR: "table2-tr" as const,
  TABLE2_TD: "table2-td" as const,

  PAGE_HEADER: "page-header" as const,
  PAGE_FOOTER: "page-footer" as const,
};
